import { render, staticRenderFns } from "./Viewer3D.vue?vue&type=template&id=740cb883&scoped=true&"
import script from "./Viewer3D.vue?vue&type=script&lang=js&"
export * from "./Viewer3D.vue?vue&type=script&lang=js&"
import style0 from "./Viewer3D.vue?vue&type=style&index=0&id=740cb883&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740cb883",
  null
  
)

export default component.exports